// @flow
import { createMuiTheme } from "@material-ui/core";
import red from "@material-ui/core/colors/red";
import dev from "./dev";

const isIos = dev.isIos();

const themeCreator = (prefersDarkMode: boolean) =>
  createMuiTheme({
    typography: {
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
    },
    palette: {
      type: prefersDarkMode ? "dark" : "light",
      primary: {
        main: "#0cb376",
        contrastText: "#FFF",
      },
      secondary: {
        main: red[500],
      },
      background: {
        default: prefersDarkMode ? "#000" : "#F3F4F5",
        paper: prefersDarkMode ? "#161618" : "#FFF",
      },
    },
    overrides: {
      MuiListItemIcon: {
        root: {
          minWidth: 46,
        },
      },
      MuiBottomNavigation: {
        root: {
          borderColor: prefersDarkMode ? "#2B2B2D" : "#E5E5EA",
          boxSizing: "content-box",
          paddingBottom: `env(safe-area-inset-bottom)`,
          touchAction: "manipulation",
          ...(isIos
            ? {
                backgroundColor: prefersDarkMode
                  ? "rgba(18, 17, 18, 0.8)"
                  : "rgba(250, 250, 251, 0.7)",
                backdropFilter: "blur(20px)",
              }
            : {
                backgroundColor: prefersDarkMode ? "#121112" : "#FAFAFB",
              }),
        },
      },
      MuiAccordionSummary: {
        root: {
          touchAction: "manipulation",
        },
      },
      MuiAppBar: {
        root: {
          boxSizing: "content-box",
          paddingTop: "env(safe-area-inset-top)",
          ...(isIos || true
            ? {
                backgroundColor: prefersDarkMode
                  ? "rgba(18, 17, 18, 0.8)"
                  : "rgba(250, 250, 251, 0.7)",
                borderColor: prefersDarkMode ? "#2B2B2D" : "#E5E5EA",
                boxShadow: "0 0 0 0 !important",
                borderBottomWidth: 1,
                borderBottomStyle: "solid",
                backdropFilter: "blur(20px)",
              }
            : {}),
        },
      },
      MuiAlert: {
        action: {
          alignItems: 'flex-start'
        }
      },
      MuiBottomNavigationAction: {
        root: {
          minWidth: "auto",
          color: prefersDarkMode ? "#8E8D92" : "#8D949D",
        },
        label: {
          fontSize: "0.75rem !important",
        },
      },
      MuiDrawer: {
        paperAnchorBottom: {
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        },
      },
      MuiFormControl: {
        root: {
          width: "100%",
        },
      },
      MuiInputBase: {
        root: {
          width: "100%",
        },
      },
      MuiSnackbarContent: {
        root: {
          marginTop: "env(safe-area-inset-top)",
          marginBottom: "env(safe-area-inset-bottom)",
        },
      },
      MuiCardContent: {
        root: {
          "&:last-child": {
            paddingBottom: 16,
          },
        },
      },
    },
  });

export default themeCreator;
